export const specialSymbols: any = {
  '®': '&reg;',
  '™': '&trade;',
  '©': '&copy;',
};
